import { Injectable } from '@angular/core';

import { Filter } from '../../../models';
import { BaseFilterCollapse } from '../filter';
import { SessionStorageService } from '../web-storage';
import { VisualizacaoStorage } from './visualizacao-storage';

/**
 * Service utilizado para armazenar os dados da visualização, tais como,
 * o filtro e página da tabela atuais da pesquisa.
 */
@Injectable({
    providedIn: 'root'
})
export class VisualizacaoStorageService {
    // private key = 'visualizacaoData';

    constructor(private sessionStorageService: SessionStorageService) { }


    /** Obtem os dados armazenados da visualização atual */
    get(key = 'visualizacaoData'): VisualizacaoStorage {
        const data = this.sessionStorageService.getObject(key) as VisualizacaoStorage;
        if (data) {
            // Sempre reconstrói o filterValues como Map (JSON desserializa Map como objeto plano)
            data.filterValues = new Map();
            if (data.filter) {
                const filterKeys = Object.keys(data.filter);
                filterKeys.forEach(filterKey => data.filterValues.set(filterKey, data.filter[filterKey]));
            }
        }

        return data;
    }

    /** Armazena os dados da visualização atual */
    set(filter: Filter, filterSearch = '', currentPage = 0, order = [], scrollerStartPosition = 0, key = 'visualizacaoData') {
        const data = new VisualizacaoStorage(filter, filterSearch, currentPage, order, scrollerStartPosition);
        this.sessionStorageService.setObject(key, data);
    }

    /** Limpa os dados da visualização */
    clear(key = 'visualizacaoData') {
        this.sessionStorageService.remove(key);
    }

    /** Obtem o filtro da pesquisa simples nos dados armazenados da visualização */
    getFilterSearch(key = 'visualizacaoData'): string {
        const data = this.sessionStorageService.getObject(key) as VisualizacaoStorage;
        return data ? data.filterSearch : '';
    }

    /** Obtem a página atual da tabela nos dados armazenados da visualização */
    getCurrentPage(key = 'visualizacaoData'): number {
        const data = this.sessionStorageService.getObject(key) as VisualizacaoStorage;
        return data ? data.currentPage : 0;
    }

    /** Obtem a ordenação atual da tabela nos dados armazenados da visualização */
    getOrder(key = 'visualizacaoData'): any[] {
        const data = this.sessionStorageService.getObject(key) as VisualizacaoStorage;
        return data ? data.order : [];
    }

    /** Aplica o filtro avançado armazenado no objeto do filtro informado */
    applyFilter(filter: Filter, filterCollapse: BaseFilterCollapse = null) {
        const vs = this.get();
        if (vs != null && vs.filterValues) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                vs.filterValues.forEach((value, key) => filter[key] = value);
            }
            // Setando o filterCollapse como "sujo"
            if (filterCollapse) {
                filterCollapse.isFilterDirty = true;
            }
        }
    }
}
